import styled from "styled-components";

export const Container = styled.span`
    display: block;
    margin: -0.01rem 0 1rem 0;
    color: ${props => props.theme.color.red};
    font-size: 0.9rem;
    font-weight: bold;
`;